import { Accordion, Loader, Tab } from '@scuf/common';
import { RmaModelLiteMf } from 'models';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { REPAIR_CENTER, RMAMANUFATURA } from 'resources';
import {
    AddressAccordion,
    Administrative,
    EquipmentsAccordion,
    FileTab,
    OrderAccordion,
    Requests,
    ServiceOrdersAccordion,
    ShippingAccordion
} from './components';
import useFetch from 'helpers/hooks/useFetch';
import Alert from 'components/alert';
import RepairCenterChat from './components/tabs/chat';
import useUser from 'helpers/hooks/useUser';
import { RmaChatTableMf } from 'models/rmamanufatura/detailsRma';
import { RmaLiteMf } from 'resources/atoms/rmaManufaturaAtom';

const RmaDetailsSelected: React.FC = () => {
    const { user: userDetails } = useUser();
    const { t } = useTranslation(['rmamanufatura', 'common']);
    const [rmaState, setRmaState] = useRecoilState<RmaModelLiteMf>(RmaLiteMf);
    const { user } = useUser();
    const [unreadMessage, setUnreadMessage] = useState<number>(0);
    const navigate = useNavigate();
    const location = useLocation();

    const [, getRmaManufacturingDetails, loading] = useFetch<{ rmaId: number }>({
        url: RMAMANUFATURA.getRmaManufacturingDetails,
        redirectOnError: true
    });

    const [chats, loadChats] = useFetch<{ roleId: number; ssoId: string; companyId: number; rmaId: number }, RmaChatTableMf[]>({
        url: REPAIR_CENTER.getAllChats
    });

    useEffect(() => {
        const rmaId = rmaState?.id || extractRmaIdFromUrl(location.pathname);
        if (user) {
            loadChats({
                roleId: parseInt(user.role),
                ssoId: user.ssoid,
                companyId: user.company,
                rmaId: rmaId
            });
        }
        getDetails(rmaId);
        addRmaIdToUrl(location.pathname);
    }, []);

    useEffect(() => {
        UnreadMessage();
    }, [chats]);

    const extractRmaIdFromUrl = (url: string): number => {
        const id = url.lastIndexOf('/');
        const rmaid = Number(url.substring(id + 1));
        return rmaid;
    };

    const addRmaIdToUrl = (url: string) => {
        if (!extractRmaIdFromUrl(url)) {
            navigate('/rma-manufatura');
        }
    };

    const UnreadMessage = () => {
        chats?.data?.forEach(e => {
            if ((user?.role == '1' || user?.role == '2') && e.itWasReadByAdmin === false) {
                setUnreadMessage(parseInt(e.message));
            } else if ((user?.role == '3' || user?.role == '4') && e.itWasReadByCustomer === false) {
                setUnreadMessage(parseInt(e.message));
            }
        });
    };

    async function getDetails(rmaNumberClick: number) {
        await getRmaManufacturingDetails({ rmaId: rmaNumberClick }, current => {
            setRmaState(current.data);
    });
}

    const shouldShowReceiveAddress = () => {
        const shipping = rmaState?.shipping;
        const situation = rmaState?.situation;
        const statusId = rmaState?.statusId;
        const hasAddress = !!rmaState?.addressId;

        const isValidShipping = shipping === 'ENVIO PELA HONEYWELL' || shipping === 'ENVIO PELO CLIENTE' || 'COLETA TRANSPORTADORA';
        const isApprovedSituation = situation === 'APROVADO';
        const isAwaitingCustomerStatus = statusId === 54;

        return (isValidShipping && isApprovedSituation && isAwaitingCustomerStatus) || hasAddress;
    };

    const accordionChildren = [
        <Accordion.Content title={t('rma.order.Order')} key="order">
            <OrderAccordion />
        </Accordion.Content>,
        shouldShowReceiveAddress() ? (
            <Accordion.Content title={t('rma.order.ReceiveAddress')} key="address">
                <AddressAccordion />
            </Accordion.Content>
        ) : null,
        // <Accordion.Content title={t('common:translation.Shipping')} key="shipping">
        //     {!!rmaState?.package?.id ? <ShippingAccordion /> : <Alert text={t('notification:information.NoData')} />}
        // </Accordion.Content>,
        <Accordion.Content
            title={`${t('common:translation.Equipments')}/${t('common:translation.Accessories')}`}
            key="equipments"
        >
            <EquipmentsAccordion />
        </Accordion.Content>,
         <Accordion.Content title={t('translation.ServiceOrders')} key="serviceOrders">
            <ServiceOrdersAccordion numberPV={rmaState?.numberPV}/>
        </Accordion.Content>
    ].filter(Boolean);

    return (
        <>
            {loading || !rmaState ? (
                <Loader text={t('common:actions.Loading')} />
            ) : (
                <div className="wrap-content">
                    <Tab className="tab-with-divider">
                        <Tab.Pane title={t('common:translation.Summary')}>
                            <Accordion>{accordionChildren}</Accordion>
                        </Tab.Pane>
                        {/* <Tab.Pane title={t('common:tabs.Chat')} badge={unreadMessage}>
                            <RepairCenterChat rmaId={rmaState?.id} />
                        </Tab.Pane> */}
                        <Tab.Pane title={t('common:tabs.Files')}>
                            <FileTab />
                        </Tab.Pane>
                        {userDetails?.role == '1' || userDetails?.role == '2' ? (
                            <Tab.Pane title={t('common:tabs.Administrative')}>
                                <Administrative />
                            </Tab.Pane>
                        ) : (
                            []
                        )}
                    </Tab>
                </div>
            )}
        </>
    );
};

export default RmaDetailsSelected;
